import { render, staticRenderFns } from "./simplified-dialog.vue?vue&type=template&id=af62f570&scoped=true&lang=pug&"
import script from "./simplified-dialog.vue?vue&type=script&lang=ts&"
export * from "./simplified-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./simplified-dialog.vue?vue&type=style&index=0&id=af62f570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af62f570",
  null
  
)

export default component.exports